import React from 'react';
import './SHDGlow.css';
import { SHDGlowProps } from './SHDGlow.d';

const SHDGlow: React.FC<SHDGlowProps> = ({
  color = '#8BFF6D',
  size = '50%',
  blur = '60px',
  top,
  left,
  right,
  bottom,
  style,
}) => {
  const [width, height] = size.includes(' ') ? size.split(' ') : [size, size];

  return (
    <div
      className="glow-ellipse"
      style={{
        background: color,
        width,
        height,
        filter: `blur(${blur})`,
        top,
        left,
        right,
        bottom,
        ...style,
      }}
    />
  );
};

export default SHDGlow;
